<template>
  <div>
    <el-image
      :src="$domain + 'static/noten/website/newHome/top_banner1.png'"
      alt="编程"
      style="width: 100%;height: 600px;"
    ></el-image>

    <CourseList
      v-for="(item, index) in dataList"
      :key="index"
      :courseList="item"
      :id="item.id"
    >
    </CourseList>
  </div>
</template>

<script>
import CourseList from "@/views/videoCourse/components/courseList";
import api from "@/api";
import { videoCourseList } from "@/api/port";
export default {
  components: { CourseList },
  mounted() {
    this.getDataList();
  },
  data() {
    return {
      imageList: [
        "static/noten/website/videoCourse/chuangzuo_title1.png",
        "static/noten/website/videoCourse/chuangzuo_title2.png",
        "static/noten/website/videoCourse/chuangzuo_title3.png"
      ],
      dataList: []
    };
  },
  methods: {
    getDataList() {
      api
        .post(videoCourseList.getCourseList, {})
        .then(res => {
          this.dataList = res.list;
        })
        .catch(error => {
          // 捕获异常并处理
          console.error("Error:", error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/videoCourse/index.vue